import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export const useTimer = (targetUnix) => {
  const [countDown, setCountDown] = useState(targetUnix - dayjs().unix());

  useEffect(() => {
    const interval = setInterval(() => {
      const diff = Math.floor(targetUnix - dayjs().unix());
      if (diff <= 0) {
        setCountDown(0);
        clearInterval(interval);
      }
      setCountDown(diff);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetUnix]);

  return countDown;
};
